import style from 'assets/scss/philosophy.module.css';

export default function Philosophy({theme}) {
    return (
        <section id="philosophy" >
            <div className={`bg-[#242f6f] p-5`}>
                <div className="container block mx-auto h-full">
                    <div className="grid md:grid-cols-2 gap-16 h-full">
                        <div className="__imgWrapper">
                            <img src="/assets/img/_1.png" className='max-w-full' alt="" />
                        </div>
                        <div className={style.__content}>
                            <div className="block mb-10">
                                <div className="flex items-end gap-4">
                                    <div className="text-4xl text-orange font-light font-mm leading-none">UNLEASH</div>
                                    <div className="text-2xl text-orange font-light font-mm leading-[1.5]">your</div>
                                </div>
                                <div className="flex items-end sm:gap-4 gap-3">
                                    <div className="text-7xl text-5xl text-yellow font-bold font-mm leading-none">Inner</div>
                                    <div className="text-7xl text-5xl text-yellow font-bold font-mm leading-none"> Dragon</div>
                                </div>
                            </div>
                            <div className="block mb-5">
                                <div className="flex items-end gap-4">
                                    <div className="text-4xl text-orange font-light font-mm leading-none">CELEBRATE</div>
                                    <div className="text-2xl text-orange font-light font-mm leading-[1.75]">your</div>
                                </div>
                                <div className="flex items-end sm:gap-4 gap-3">
                                    <div className="sm:text-7xl text-5xl text-yellow font-bold font-mm leading-none">Inner</div>
                                    <div className="sm:text-7xl text-5xl text-yellow font-bold font-mm leading-none"> Bruce Lee</div>
                                </div>
                            </div>
                            <div className="block mb-5">
                                <div className="flex items-end gap-4">
                                    <p className="text-lg text-white">Join a community that celebrates the icon’s foundation of individuality, inclusiveness, and integrity.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container block mx-auto h-full">
                    <div className="grid md:grid-cols-2 gap-16 h-full">
                        <div className={style.__content}>
                            <div className="block mb-10 relative">
                                <div className="flex items-end flex-col justify-end gap-4">
                                    <div className="text-2xl text-yellow font-light font-mm leading-none">All in all, the goal of my planning and doing is to find the true meaning in life: peace of mind.</div>
                                    <div className="text-2xl text-yellow font-light font-mm leading-none">- Bruce Lee</div>
                                </div>
                            </div>
                            <div className="block mb-5">
                                <div className="flex items-end flex-col justify-end gap-4">
                                    <p className="text-lg text-white">Bruce Lee’s legacy inspired others more than just martial arts, allowing people to embrace their uniqueness and finding the best versions of themselves, while staying grounded to their culture. We incite positive change in communities with programs and events that will impact our society for the better.</p>
                                    <p className="text-lg text-white">We bring together a community of like-minded individuals to slowly begin to understand themselves and as a result, be more accepting of others.</p>
                                </div>
                            </div>
                        </div>
                        <div className="__imgWrapper">
                            <img src="/assets/img/_2.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}